import { useContent } from "../content-context";

function Row({ hidden = false }) {
  const { marquee } = useContent();
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {marquee.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-display text-3xl italic text-ivory/90 md:px-14 md:text-5xl">{item}</span>
          <span className="h-2 w-2 rotate-45 bg-gold" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="brand-marquee"
      className="overflow-hidden border-y border-gold/20 bg-navy py-7 md:py-9"
    >
      <div className="anim-marquee flex w-max whitespace-nowrap">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
